<script setup>
import BaseButton from './BaseButton.vue'
import BaseModal from './BaseModal.vue'
import { useConfirm } from '../../composables/useConfirm'
const { state, confirm, cancel } = useConfirm()
</script>
<template>
  <BaseModal :open="state.open" :title="state.title" size="sm" :close-on-backdrop="false" @request-close="cancel">
    <p class="text-sm font-semibold leading-6 text-app-muted">{{ state.message }}</p>
    <template #footer>
      <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <BaseButton variant="secondary" @click="cancel">{{ state.cancelText }}</BaseButton>
        <BaseButton :variant="state.tone === 'danger' ? 'danger' : 'primary'" @click="confirm">{{ state.confirmText }}</BaseButton>
      </div>
    </template>
  </BaseModal>
</template>
